import React, { useState } from "react";
import bgImage from "../image/image1.png";
import { FaPhoneAlt, FaLinkedin, FaGlobeAmericas } from "react-icons/fa";
import { FaSquareInstagram } from "react-icons/fa6";
import { IoMdMail } from "react-icons/io";
import { MdLocationOn } from "react-icons/md";
import Navigation from "./Navbar";
import Footer from "./Footer";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      // Convert data to URL-encoded for Apps Script
      const formBody = new URLSearchParams(formData).toString();

      const response = await fetch("https://script.google.com/macros/s/AKfycbye1Ef-guZDc0WVvnybozQwWguITUemGSwEaAyz0qRGjADXQm7Sr1u7YtQek5RLvk6r/exec", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formBody,
      });

      const result = await response.json();

      if (result.status === "success") {
        // Success alert for user
        alert(
          `Thank you for connecting with us, ${formData.name} \n\nOur team will contact you shortly.`
        );
        setFormData({ name: "", email: "", phone: "", message: "" });
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.error(error);
      alert("Server error. Please try later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
     <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
    <Navigation/>
   </div>
    <div id="contact" className="relative min-h-screen flex items-center justify-center p-4 pt-[114px] lg:pt-[160px]">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed opcity-20"
        style={{ backgroundImage: `url(${bgImage})` }}
      />
       {/* Overlay for readability */}
      <div className="absolute inset-0 bg-white/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-6xl w-full py-12">
        {/* Header Section */}
        <div className="text-center mb-12 text-blue-900">
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            Bringing Together Public Health <br/>
            <span className="text-orange-500 italic">Policy Stakeholders</span>
          </h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto opacity-90">
            A global think tank dedicated to Policy stakeholders, Experts, and Patient & Public Advocacy Groups
          </p>
          <div className="mt-6 flex justify-center">
            <div className="w-20 h-1 bg-gradient-to-r from-transparent via-orange-500 to-transparent"></div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Left Contact Info Section */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-white/20">
            <h2 className="text-2xl font-bold text-blue-900 mb-6 flex items-center gap-2">
              <div className="w-2 h-8 bg-orange-500 rounded-full"></div>
              Get in Touch
            </h2>
            
            <div className="space-y-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-900/10 flex items-center justify-center">
                  <MdLocationOn className="text-blue-900 text-xl" />
                </div>
                <div>
                  <h3 className="font-semibold text-blue-900 mb-1">Our Headquarter</h3>
                  <p className="text-gray-700">Lucknow, India</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                
              
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-blue-900/10 flex items-center justify-center">
                  <IoMdMail className="text-blue-900 text-xl " />
                </div>
                <div>
                  <h3 className="font-semibold text-blue-900 mb-1"> Email</h3>
                  <p className="text-gray-700">we@gdphdhealth.org</p>
                    <div>
                 
                  <p className="text-gray-600 text-sm mt-1">Mon-Fri, 9:00 AM - 6:00 PM IST</p>
                </div>
                  <p className="text-gray-600 text-sm mt-1">For policy consultations & research collaborations</p>
                </div>
              </div>

              {/* Social Media */}
              <div className="pt-4">
                <h3 className="font-semibold text-blue-900 mb-4">Connect With Our Research</h3>
                <div className="flex gap-4">
                  <a
                    href="https://www.linkedin.com/company/gdphdhealth/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-blue-900 hover:bg-blue-800 flex items-center justify-center transition-all duration-300 hover:scale-105"
                    aria-label="LinkedIn"
                  >
                    <FaLinkedin className="text-white text-xl" />
                  </a>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-orange-400 hover:from-orange-600 hover:to-orange-500 flex items-center justify-center transition-all duration-300 hover:scale-105"
                    aria-label="Instagram"
                  >
                    <FaSquareInstagram className="text-white text-xl" />
                  </a>
                  <a
                    href="https://healthpolicydialogues.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-12 h-12 rounded-full bg-gradient-to-r from-blue-900 to-blue-700 hover:from-blue-800 hover:to-blue-600 flex items-center justify-center transition-all duration-300 hover:scale-105"
                    aria-label="Website"
                  >
                    <FaGlobeAmericas className="text-white text-xl" />
                  </a>
                </div>
              </div>
            </div>

            {/* Decorative Element */}
            <div className="mt-8 pt-6 border-t border-blue-100">
              <p className="text-sm text-gray-600 italic">
                "Fostering multi-stakeholder dialogues for resilient health systems"
              </p>
            </div>
          </div>

          {/* Right Contact Form */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-8 border border-white/20">
            <div className="mb-6">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-2 h-8 bg-orange-500 rounded-full"></div>
                <h2 className="text-sm font-semibold text-blue-900 uppercase tracking-wider">
                  Policy Dialogue Inquiry
                </h2>
              </div>
              <h3 className="text-2xl font-bold text-gray-800">
                Join the Conversation
              </h3>
              <p className="text-gray-600 mt-2">
                Connect with policymakers, industry leaders, and health advocates
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
                  Full Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                  placeholder="Your Name/Organisation Name"
                />
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                    placeholder="we@gdphdhealth.org"
                  />
                </div>

                <div>
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                    Phone Number *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    pattern="^[0-9]{10,15}$"
                    title="Enter a valid phone number"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none"
                    placeholder="+91 1234567890"
                  />
                </div>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Policy Interest / Inquiry *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all outline-none resize-none"
                  rows="5"
                  placeholder="Tell us about your policy interest, potential collaboration, or specific dialogue topic related to public health..."
                ></textarea>
              </div>

              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className={`px-8 py-3 rounded-lg font-semibold text-white transition-all duration-300 ${isSubmitting
                      ? "bg-gray-400 cursor-not-allowed"
                      : "bg-gradient-to-r from-blue-900 to-blue-700 hover:from-blue-800 hover:to-blue-600 hover:shadow-lg transform hover:-translate-y-0.5"
                    }`}
                >
                  {isSubmitting ? (
                    <span className="flex items-center gap-2">
                      <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                      </svg>
                      Submitting...
                    </span>
                  ) : (
                    "Connect for Policy Dialogue"
                  )}
                </button>
              </div>

              <p className="text-sm text-gray-500 text-center mt-4">
                Your inquiry will be directed to relevant policy working groups and stakeholder networks.
              </p>
            </form>
          </div>
        </div>

        {/* Footer Note */}
        <div className="mt-8 text-center text-blue-900">
          <p className="text-sm">
            Part of the Global Health Policy Dialogues Initiative • Aligned with Viksit Bharat 2047 Goals
          </p>
        </div>
      </div>
    </div>
        <main
        className="relative z-10 "  
        
      >
        <Footer />
      </main>
    </div>
  );
};

export default Contact;